import React from 'react';
import Tooltip from 'components/Tooltip/Tooltip';
import { HelpIcon } from 'components/SvgIcons';

import './Help.scss';

export interface HelpProps {
  children: React.ReactNode | null | undefined;
}

const Help = ({ children }: HelpProps) =>
  children ? (
    <div className="enkrateia-help-tooltip">
      <Tooltip tooltip={children}>
        <HelpIcon color="var(--traroSecondary500)" size={25} />
      </Tooltip>
    </div>
  ) : null;

export default Help;
